import { Controller } from '@hotwired/stimulus'
import { removeClass } from 'utils/toggle_class'

export default class extends Controller {
  static targets = ["item"]

  clearActiveItems(e) {
    removeClass(this.itemTargets, "-active")
  }
}
